/** Whether the server had a stored PDF ready, or has queued one and wants the caller to retry. */
export enum ClaimFormPdfStatus {
  READY = 'ready',
  GENERATING = 'generating',
}

export type ClaimFormPdfResult =
  | { status: ClaimFormPdfStatus.READY; blob: Blob }
  | { status: ClaimFormPdfStatus.GENERATING }

/** Drawer download button states. */
export enum PdfDownloadState {
  IDLE = 'idle',
  DOWNLOADING = 'downloading',
  GENERATING = 'generating',
  ERROR = 'error',
}

/** Reporting-tab per-row download states. EMPTY means no archive exists for that date. */
export enum ArchiveDownloadState {
  IDLE = 'idle',
  DOWNLOADING = 'downloading',
  EMPTY = 'empty',
  ERROR = 'error',
}
